export default {
  title: 'Ativar localizador',
  subtitle: 'Digite o código do localizador e o código de ativação de 6 dígitos impressos na peça.',
  code_label: 'Código do localizador',
  code_placeholder: 'AAA-999',
  secret_label: 'Código de ativação (6 dígitos)',
  secret_hint: '6 dígitos impressos no localizador ou na embalagem.',
  name_label: 'Nome do localizador',
  name_placeholder: 'Ex.: Thor, Mochila, Chaveiro',
  category: 'Categoria',
  group_optional: 'Grupo (opcional)',
  none: 'Nenhum',
  submit: 'Ativar localizador',
  done_title: 'Localizador ativado',
  done_received: 'Localização recebida',
  done_received_body: 'Já recebemos a primeira detecção deste localizador.',
  done_waiting_body: 'A localização aparecerá quando recebermos a primeira detecção.',
  view_on_map: 'Ver no mapa',
  eyebrow: 'Porta de entrada da conta',
  hero_title: 'Ative seu localizador e comece a acompanhar',
  hero_subtitle: 'Em poucos minutos o localizador aparece no mapa, com histórico e alertas. Você só precisa dos dois códigos impressos nele.',
  hero_badge_installation: 'Sem instalação',
  hero_badge_codes: 'Códigos impressos no localizador',
  hero_badge_support: 'Suporte humano',
  step1_title: 'Identifique o localizador',
  step1_hint: 'Digite o código do localizador (AAA-999) e o PIN de 6 dígitos. Os dois ficam impressos nele ou na embalagem.',
  where_title: 'Onde encontro os códigos?',
  where_body: 'Na parte de trás do localizador ou na etiqueta da embalagem. O código do localizador segue o formato AAA-999; o código de ativação tem 6 dígitos.',
  step2_title: 'Dê um nome e escolha a categoria',
  step2_hint: 'O nome e a categoria aparecem no mapa, nos alertas e nos relatórios.',
  step3_title: 'Organize em um grupo (opcional)',
  step3_hint: 'Agrupe por casa, equipe, obra ou qualquer critério que ajude a encontrar depois.',
  no_groups: 'Nenhum grupo criado ainda. Você pode organizar depois em Dispositivos.',
  note_after: 'Você pode renomear, mover de grupo e criar cercas depois, sem refazer a ativação.',
  checklist_title: 'Antes de começar',
  checklist_1: 'Localizador em mãos',
  checklist_2: 'Código do localizador e PIN de 6 dígitos visíveis',
  checklist_3: 'Localizador ainda não ativado',
  how_title: 'Como funciona',
  how_1_title: 'Confirme os códigos',
  how_1_body: 'O código identifica a peça e o PIN de 6 dígitos prova que ela é sua.',
  how_2_title: 'Dê um nome',
  how_2_body: 'Escolha a categoria e, se quiser, um grupo.',
  how_3_title: 'Acompanhe no mapa',
  how_3_body: 'A primeira posição chega assim que o localizador for detectado.',
  licenses_title: 'Licenças de localizador',
  licenses_usage: '{used} de {limit} em uso',
  licenses_usage_unlimited: '{used} localizadores em uso',
  licenses_available: '{count} livre(s)',
  licenses_unlimited_label: 'Ilimitado',
  licenses_buy: 'Comprar mais localizadores',
  help_title: 'Precisa de ajuda?',
  help_body: 'Se o código não for aceito, envie uma foto da etiqueta para o suporte.',
  help_cta: 'Falar com suporte',
  done_eyebrow: 'Tudo certo',
  done_waiting_status: 'Aguardando primeira detecção',
  done_next_title: 'Próximos passos',
  done_next_1: 'Confira a primeira posição no mapa.',
  done_next_2: 'Crie uma cerca para receber alertas de entrada e saída.',
  done_next_3: 'Compartilhe um link temporário com quem precisar.',
  done_another: 'Ativar outro localizador',
  done_tags: 'Ver meus localizadores',
  summary_name: 'Nome',
  summary_category: 'Categoria',
  summary_group: 'Grupo',
  summary_status: 'Status',
  category_pet_hint: 'Cães, gatos e outros pets',
  category_vehicle_hint: 'Carros, motos e bikes',
  category_object_hint: 'Mochilas, malas e chaves',
  category_asset_hint: 'Ferramentas e equipamentos',
  scan_title: 'Aponte a câmera para o QR Code do seu localizador',
  scan_hint: 'A câmera só é usada para ler o código.',
  camera_unavailable: 'Câmera indisponível — digite o código abaixo.',
  scan_qr: 'Escanear QR Code',
  stop_camera: 'Parar câmera',
  or_type: 'Ou digite o código',
  check_code: 'Confira se o código bate com o do seu localizador.',
  view_my_tags: 'Ver meus localizadores',
}
